import { Dialog, DialogContent, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import IncidentDetail from './IncidentDetail';

/**
 * Full incident record as a modal over the project map, opened from a
 * marker popover's "More". Lineage links inside it switch the modal to that
 * incident (and select it on the map behind).
 */
export default function IncidentDetailModal({
    projectId,
    incidentId,
    onClose,
    onSelectIncident,
}: {
    projectId: string;
    incidentId: number | null;
    onClose: () => void;
    onSelectIncident: (incidentId: number) => void;
}) {
    const navigate = useNavigate();
    return (
        <Dialog
            open={incidentId !== null}
            onClose={onClose}
            maxWidth="xl"
            fullWidth
            PaperProps={{ sx: { height: 'calc(var(--vh100) * 0.92)', backgroundImage: 'none' } }}
        >
            <Tooltip title="Open as a page">
                <IconButton
                    size="small"
                    onClick={() => navigate(`/projects/${projectId}/incidents/${incidentId}/log`)}
                    sx={{ position: 'absolute', right: 48, top: 10, zIndex: 1, color: 'text.secondary' }}
                    aria-label="Open incident as a page"
                >
                    <OpenInNewIcon fontSize="small" />
                </IconButton>
            </Tooltip>
            <IconButton
                size="small"
                onClick={onClose}
                sx={{ position: 'absolute', right: 10, top: 10, zIndex: 1 }}
                aria-label="Close"
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ pt: 4, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                {incidentId !== null && (
                    <IncidentDetail
                        projectId={projectId}
                        incidentId={String(incidentId)}
                        onSelectIncident={onSelectIncident}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
